import { api } from 'shared/api';

import { AvailabilityRecord, FetchAvailabilityResponse } from '../types';

async function applyAvailability(payload: AvailabilityRecord[]) {
    return await api.post<AvailabilityRecord[], FetchAvailabilityResponse>('candidatePortal/availability/accept', payload);
}

async function applyAvailabilityByOldAvailabilityToken(token: string, payload: AvailabilityRecord[]) {
    return await api.post<AvailabilityRecord[], FetchAvailabilityResponse>(`Availability/AcceptByToken/${ token }`, payload);
}

export {
    applyAvailability,
    applyAvailabilityByOldAvailabilityToken
};
